var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4224 0.979492H2.42236C1.32236 0.979492 0.432363 1.87949 0.432363 2.97949L0.422363 14.9795C0.422363 16.0795 1.32236 16.9795 2.42236 16.9795H18.4224C19.5224 16.9795 20.4224 16.0795 20.4224 14.9795V2.97949C20.4224 1.87949 19.5224 0.979492 18.4224 0.979492ZM17.4224 14.9795H3.42236C2.87236 14.9795 2.42236 14.5295 2.42236 13.9795V4.97949L9.36236 9.31949C10.0124 9.72949 10.8324 9.72949 11.4824 9.31949L18.4224 4.97949V13.9795C18.4224 14.5295 17.9724 14.9795 17.4224 14.9795ZM10.4224 7.97949L2.42236 2.97949H18.4224L10.4224 7.97949Z",
    fill: "#2960EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEmail);
export default __webpack_public_path__ + "static/media/blue_email.7a9b5a915e2bbffb30a8955f4f5e5290.svg";
export { ForwardRef as ReactComponent };